import React, { useState, useEffect, useContext } from 'react'
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import ListGroup from 'react-bootstrap/ListGroup';
import { FaRegTrashAlt } from 'react-icons/fa';
import { ObjModal } from '../../../../contexts';
import AddNote from '../../../Modals/AddNote';
import { monthsShort } from '../../../../common/utils';

import { styled } from '@mui/material/styles';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import KeyboardArrowRightSharpIcon from '@mui/icons-material/KeyboardArrowRightSharp';
import MuiAccordionSummary from '@mui/material/AccordionSummary';
import { removeNote } from '../../../../common/api';
import { toast } from 'react-toastify';


const Notes = ( { aid, uid } ) => {
    const { objType, obj, openModal, closeModal, setModal } = useContext( ObjModal );
    const [ expanded, setExpanded ] = useState( false );

    useEffect( () => {
        setExpanded( obj.notes.length > 0 );
    }, [ obj.notes ] );

    const trash = async ( naid, nid ) => {
        const removed = await removeNote( naid, uid, nid );
        if ( removed.length ) {
            toast.success( `Your note has been deleted`, { theme: 'dark' } );
            // window.location.reload( false );
        }
    };

    const handleModal = ( t ) => {
        let shouldOpen = true;

        switch ( t ) {
            case 'note':
                if ( objType === 'contact' ) {
                    setModal( <AddNote close={closeModal} aid={obj.details.aid} cid={obj.details.cid} /> ); 
                } else if ( objType === 'loan' ) {
                    console.log( 'obj: ', obj );
                    let cid;
                    if ( obj.borrowers && obj.borrowers.length ) {
                        cid = obj.borrowers[0].cid;
                    }
                    setModal( <AddNote close={closeModal} aid={obj.details.aid} cid={cid} lid={obj.details.lid} /> ); 
                }
                break;

            default:
                console.log( 'Unknown modal type: ' + t );
                shouldOpen = false;
        }

        if ( shouldOpen ) {
            openModal();
        }
    }

    const formatDate = ( d ) => {
        if ( d ) {
            const [ yr, mon, dd ] = d.replace( /[T\s].*/, '' ).split( '-' );
            return `${monthsShort[parseInt(mon) - 1]} ${dd}, ${yr}`;
        }
        return '';
    }

    const AccordionSummary = styled( ( props ) => (
        <MuiAccordionSummary expandIcon={<KeyboardArrowRightSharpIcon sx={{ fontSize: '0.9rem' }} />} {...props} />
    ) ) ( ( { theme } ) => ( {
        backgroundColor:
          theme.palette.mode === 'dark'
            ? 'rgba(255, 255, 255, .05)'
            : 'rgba(0, 0, 0, .03)',
        flexDirection: 'row-reverse',
        '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
            transform: 'rotate(90deg)',
        },
        '& .MuiAccordionSummary-content': {
            marginLeft: theme.spacing(1),
        },
    } ) );

    return (
        <Container fluid className='p-0'>
            <Accordion expanded={expanded}>
                <AccordionSummary expandIcon={<KeyboardArrowRightSharpIcon onClick={ () => setExpanded( !expanded ) } />}>
                    <Row className='align-items-center w-100'>
                        <Col><Typography>Internal Notes ({obj.notes.length})</Typography></Col>
                        <Col xs='auto' className='p-0'><Button variant='outline-primary' size='sm' onClick={ () => handleModal( 'note' ) }>+ Add</Button></Col>
                    </Row>
                </AccordionSummary>
                <AccordionDetails>
                    <ListGroup variant='flush' className='overflow-scroll' style={ { maxHeight: '400px' } }>
                    { obj.notes.map( ( n, idx ) => (
                        <ListGroup.Item key={idx}>
                            <Row className='align-items-center'>
                                <Col xs='auto' className='tf-sidebar-obj-value'>
                                    { formatDate( n.createdDate ) }
                                </Col>
                                <Col>
                                    <Row>
                                        <Col xs='auto' className='p-1 ps-3 pb-0'>
                                            <Link to={`/note/${n.nid}`}>{n.name}</Link>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col xs='auto' className='p-1 ps-3 pt-0'>
                                            { n.createdBy }
                                        </Col>
                                    </Row>
                                </Col>
                                <Col xs='auto'><FaRegTrashAlt className='tf-sidebar-trash' onClick={ () => trash( n.aid, n.nid ) } /></Col>
                            </Row>
                            <Row className='overflow-scroll' style={ { maxHeight: '200px' } }>    
                                {
                                    ( n.video ) ? (
                                        <Col className='pt-2'>
                                            <video src={`https://tf-media.s3.amazonaws.com/${aid}/${n.mediaUrl}`} controls playsInline style={ { height: '180px' } }></video>
                                        </Col>
                                    ) : ( n.audio ) ? (
                                        <Col className='pt-2'>
                                            <audio src={`https://tf-media.s3.amazonaws.com/${aid}/${n.mediaUrl}`} controls playsInline></audio>
                                        </Col>
                                    ) : (
                                        <Col dangerouslySetInnerHTML={ { __html: n.details } } />
                                    )
                                }
                            </Row>
                        </ListGroup.Item>
                    ) ) }
                    </ListGroup>
                </AccordionDetails>
            </Accordion>
        </Container>
    )
}

const mapProps = ( state ) => ( {
    aid: state.user.aid,
    uid: state.user.email
} );

const mapDispatch = ( dispatch ) => ( {
    // removeContact: dispatch.lists.removeContact,
    // removeLoan: dispatch.lists.removeLoan
} );

export default connect( mapProps, mapDispatch )( Notes );